import {
  DashboardRounded,
  PeopleAltRounded,
  SensorsRounded,
  TimelineRounded,
  NotificationsActiveRounded,
  AssessmentRounded,
  AccountCircleRounded,
  TuneRounded,
  SystemUpdateAltRounded,
  MapRounded,
  HistoryRounded,
  AssignmentIndRounded,
  BusinessRounded,
  ViewCarouselRounded,
  CreditCardRounded,
} from '@mui/icons-material';

/**
 * Role aware navigation model.
 * Administrators receive the full command surface, operators only see the
 * modules that apply to devices assigned to them.
 */
export const ADMIN_NAV = [
  { key: 'dashboard', label: 'Dashboard', icon: DashboardRounded, path: '/dashboard' },
  { key: 'users', label: 'Users', icon: PeopleAltRounded, path: '/users', adminOnly: true },
  { key: 'devices', label: 'Devices', icon: SensorsRounded, path: '/devices' },
  { key: 'device-data', label: 'Device Data', icon: TimelineRounded, path: '/device-data' },
  { key: 'alerts', label: 'Alerts', icon: NotificationsActiveRounded, path: '/alerts' },
  { key: 'reports', label: 'Reports', icon: AssessmentRounded, path: '/reports' },
  { key: 'profile', label: 'Profile', icon: AccountCircleRounded, path: '/profile' },
  { key: 'settings', label: 'Settings', icon: TuneRounded, path: '/settings', adminOnly: true },
];

/** Secondary administration modules inherited from the platform core. */
export const SYSTEM_NAV = [
  { key: 'firmware', label: 'Firmware', icon: SystemUpdateAltRounded, path: '/firmware' },
  { key: 'signage', label: 'Signage Media', icon: ViewCarouselRounded, path: '/signage' },
  { key: 'allocation', label: 'Device Allocation', icon: AssignmentIndRounded, path: '/allocation' },
  { key: 'sub-offices', label: 'Sub Offices', icon: BusinessRounded, path: '/sub-offices' },
  { key: 'subscription', label: 'Subscription', icon: CreditCardRounded, path: '/subscription' },
  { key: 'map', label: 'Map Workspace', icon: MapRounded, path: '/map-settings' },
  { key: 'audit', label: 'Audit Trail', icon: HistoryRounded, path: '/audit-logs' },
];

export const buildNavigation = (role) => {
  const isAdmin = role === 'admin';
  const primary = ADMIN_NAV.filter((item) => !item.adminOnly || isAdmin).map((item) =>
    // operators see their own slice of the fleet
    !isAdmin && item.key === 'devices' ? { ...item, label: 'My Devices' } : item
  );
  const secondary = isAdmin ? SYSTEM_NAV : [];
  return { primary, secondary };
};

export const PAGE_META = {
  '/dashboard': { title: 'IoT Command Center', subtitle: 'Real-time device intelligence' },
  '/users': { title: 'User Directory', subtitle: 'Operator provisioning and access control' },
  '/devices': { title: 'Device Fleet', subtitle: 'Register, assign and monitor endpoints' },
  '/device-data': { title: 'Device Data', subtitle: 'Live readings and historical telemetry' },
  '/alerts': { title: 'Alert Center', subtitle: 'Severity-based events across the fleet' },
  '/reports': { title: 'Reports', subtitle: 'Operational analytics and export' },
  '/profile': { title: 'Profile', subtitle: 'Account identity and credentials' },
  '/settings': { title: 'Settings', subtitle: 'Console and platform preferences' },
  '/signage': { title: 'Signage Media', subtitle: 'Digital signage content distribution' },
  '/firmware': { title: 'Firmware', subtitle: 'Device firmware packages' },
  '/allocation': { title: 'Device Allocation', subtitle: 'Assign endpoints to operators' },
  '/sub-offices': { title: 'Sub Offices', subtitle: 'Organisational structure' },
  '/map-settings': { title: 'Map Workspace', subtitle: 'Geospatial telemetry layers' },
  '/audit-logs': { title: 'Audit Trail', subtitle: 'Administrative action history' },
  '/subscription': { title: 'Subscription', subtitle: 'Plan, device quota and data allowance' },
};

export const metaForPath = (pathname) => {
  if (pathname.startsWith('/devices/')) {
    return { title: 'Device Profile', subtitle: 'Live telemetry and device diagnostics' };
  }
  return PAGE_META[pathname] || { title: 'IoT Command Center', subtitle: 'Real-time device intelligence' };
};
